import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'app-placeholder-feed',
  templateUrl: './placeholder-feed.component.html',
  styleUrls: ['./placeholder-feed.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlaceholderFeedComponent implements OnInit {
  @Input() grouped: boolean;

  constructor() {}

  ngOnInit() {}
}
